import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20artistic%20background%20with%20soft%20gradients%20of%20warm%20amber%20cream%20and%20terracotta%20tones%2C%20flowing%20organic%20shapes%2C%20gentle%20textures%2C%20a%20feeling%20of%20community%20and%20connection%2C%20minimalist%20ethereal%20style%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="海角社区温暖交流平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/25"></div>
      </div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <p className="text-sm md:text-base text-white/80 tracking-widest mb-4 font-label">
          欢迎来到 · 海角社区
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          连接你我<span className="text-primary-300">的温暖</span>交流平台
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          一个开放、包容的在线社区，汇聚来自五湖四海的朋友。分享生活、情感、兴趣与故事，找到志同道合的伙伴，畅所欲言，感受真实的人与人之间的温度与连接。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/about#contact"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即加入社区
          </a>
          <Link
            to="/category/life"
            className="px-8 py-3 border border-white/40 text-white rounded-full text-base font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            探索精彩内容
          </Link>
        </div>
        <div className="mt-14 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="text-center">
            <p className="text-2xl font-bold text-white">12,680+</p>
            <p>社区成员</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl font-bold text-white">546</p>
            <p>精彩文章</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl font-bold text-white">6</p>
            <p>内容分类</p>
          </div>
        </div>
      </div>
    </section>
  );
}